module.exports = __webpack_public_path__ + "img/visa.fff749c2.svg";